export default __webpack_public_path__ + "static/media/esgot-screenshot-05.6e82f103.png";